/* eslint-disable */
import { Button } from '@synergy-marine-group/synergy-ui';
import { Field, FieldArray } from 'formik';
import React, { useEffect, useState, useMemo } from 'react';
import { orderBy } from 'lodash';
import { Chip } from '@material-ui/core';
import polygon from '../../images/icons/polygon.svg';
import getCurrencyList from '../vendor/queries/getCurrency';
import formatDropdownOptions from '../../utils/formatDropdownOptions';
import ExpenseFieldForm from './ExpenseFieldForm';
import VesselAdhocPPE from './VesselAdhocPPE';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import showAlert from '../../utils/alert';

const checkCrewError = ({ touched, errors, fieldName, index }) => {
  if (touched?.[index]?.[fieldName] && errors?.[index]?.[fieldName]) {
    return errors?.[index]?.[fieldName];
  }
  return '';
};

const checkDisable = (crewList) => {
  if (!crewList || crewList.length === 0) return false;
  const last = crewList[crewList.length - 1];
  if (!last) return false;
  // Add Item enabled only when last line has Expense Line Item selected
  return !last?.expenseLineItemId;
};

const VesselForm = ({ values, dataObj, mode, errors, touched, setFieldValue, expenseitemsData, vesselList, expenseCategoryList, companyId, setcreatedAccountCode, savedaccountCode, setSavedAccountCode, plannedVesselRevisionId }) => {
  const [openCrew, setopenCrew] = useState(true);
  const [showDropdown, setShowDropdown] = useState(true);
  const [vesselData, setVesselData] = useState(null);
  const [vesselIndex, setVesselIndex] = useState(null);
  const [clicked, setClicked] = useState(false);
  const [isbtndisabled, setisbtndisabled] = useState(false);
  const [category, setCategory] = useState(null);
  const sapPoNumberPosition = values?.sapPoNumberPosition || dataObj?.sapPoNumberPosition || '-';
  const normalizedSapPoNumberPosition = sapPoNumberPosition.toLowerCase().replace(/[^a-z]/g, '');
  const showLineItemSapPoNumber = normalizedSapPoNumberPosition.includes('lineitem');

  const { data: currencies } = getCurrencyList();

  useEffect(() => {
    if (values?.expenseCategoryId) {
      const selectedCategory = expenseCategoryList?.find(
        (item) => item?.value === values?.expenseCategoryId
      );
      setCategory(selectedCategory);
    }
  }, [values?.expenseCategoryId]);

  const calculateTotalAmount = () => {
    const total = values?.purchaseOrderCrew?.reduce((sum, crew) => {
      return sum + (crew?.amount ? parseFloat(crew?.amount) : 0);
    }, 0);
    return total > 0 ? total : 0;
  };

  const getCurrency = () => {
    return currencies?.data?.find((item) => item?.id === values?.currencyId)?.code;
  };

  const getAccountCode = (index) => {
    const crew = values?.purchaseOrderCrew?.[index];
    if (!crew) return '';
    const expenseLineItemID = crew?.expenseLineItemId;
    const matchedItem = expenseitemsData?.find(
      (item) => String(item?.expenseLineItemID ?? item?.value) === String(expenseLineItemID)
    );
    if (matchedItem?.companyExpenseAccountCodeList?.length > 0) {
      const companyMatch = matchedItem.companyExpenseAccountCodeList.find(
        (entry) => String(entry.companyId) === String(companyId)
      );
      if (companyMatch?.accountCodeName) {
        return companyMatch.accountCodeName;
      }
    }
    return (
      matchedItem?.accountCode
      || crew?.accountCode
      || savedaccountCode?.[index]?.accountCode
      || ''
    );
  };

  useEffect(() => {
    const isDisabled = checkDisable(values?.purchaseOrderCrew);
    setisbtndisabled(isDisabled);
  }, [values?.purchaseOrderCrew]);

  useEffect(() => {
    const crewArray = values?.purchaseOrderCrew;
    if (crewArray == null ) return;
    const newAccountCode = getAccountCode(vesselIndex);
    if (newAccountCode) {
      setFieldValue(`purchaseOrderCrew[${vesselIndex}].accountCode`, newAccountCode);
      setcreatedAccountCode(newAccountCode);
      if (typeof setSavedAccountCode === 'function') setSavedAccountCode(newAccountCode);
    }
  }, [vesselIndex, expenseitemsData, values?.purchaseOrderCrew]);

  return (
    <>
      <FieldArray
        name="purchaseOrderCrew"
        render={({ push, remove }) => {
          return (
            <>
              <div
                onClick={() => setopenCrew(!openCrew)}
                className="flex flex-row place-content-between mb-4 mt-4 bg-secondary-500 p-1 px-2.5 rounded-md cursor-pointer"
              >
                <div className="text-base font-muli text-white-light font-bold">
                  Add Line Item
                </div>
                <img src={polygon} alt="polygon" className={`${!openCrew ? 'transform -rotate-90' : ''} w-6`} />
              </div>

              {openCrew && (
                <div>
                  <div className="flex justify-end p-4">
                    <div className="text-right">
                      <span className="pr-2 font-bold text-xl">Total:</span>
                    </div>
                    <div className="text-right text-secondary-900">
                      <span className="font-bold text-xl">{getCurrency() || ''} </span>
                      <span className="font-bold text-xl">{Number(calculateTotalAmount()).toFixed(2)}</span>
                    </div>
                  </div>

                  {values?.purchaseOrderCrew && values?.purchaseOrderCrew?.length > 0 ? (
                    values.purchaseOrderCrew.map((crew, index) => {
                      return (
                        <>
                          <div className="p-5 mb-4" style={{ border: '2px solid #EEEEEE', borderRadius: '10px' }}>
                             {crew?.isShortClosed && (
                                  <div className="w-full flex justify-end mb-2">
                                    <Chip variant="outlined" className="text-white-light" label="Short Closed" />
                                  </div>
                                )}
                            {/* {crew.vesselName || crew.plannedVesselName ? (
                              <div className="mt-2 flex flex-row justify-between mb-4">
                                <div className="w-full md:w-1/4">
                                  <span className="text-md"> Vessel Name :</span>
                                  <span className="font-bold text-md">{crew.vesselName ? crew.vesselName : crew.plannedVesselName || '-'}</span>
                                </div>
                                <div className="w-full md:w-1/4">
                                  <span className="text-md"> Vessel Code :</span>
                                  <span className="font-bold text-md">{crew.vesselCode ? crew.vesselCode : crew.plannedVesselCode || '-'}</span>
                                </div>
                                <div className="w-full md:w-1/4">
                                  <span className="text-md"> IMO :</span>
                                  <span className="font-bold text-md">{crew.imo ? crew.imo : crew.plannedVesselImo || '-'}</span>
                                </div>
                                {crew?.isShortClosed && (
                                  <div className="w-full md:w-1/3 text-right">
                                    <Chip variant="outlined" className="text-white-light" label="Short Closed" />
                                  </div>
                                )}
                              </div>
                            ) : null} */}

                            <div className="grid grid-cols-3 gap-6 p-1">
                              {/* <div className="required-field">
                                {showDropdown ? (
                                  <div className="required-field">
                                    <Field
                                      name={`purchaseOrderCrew[${index}].plannedVesselId`}
                                      component={DropdownFieldComponent}
                                      setChangedValue={(item, ind) => {
                                        setVesselData(item);
                                        setVesselIndex(index);
                                      }}
                                      special={
                                        vesselList?.find(
                                          (v) => v.value === values?.purchaseOrderCrew?.[index]?.plannedVesselRevisionId
                                        ) || null
                                      }
                                      customOnChange={(option, form) => {
                                        form.setFieldValue(
                                          `purchaseOrderCrew[${index}].plannedVesselId`,
                                          option?.id || ''
                                        );
                                        form.setFieldValue(
                                          `purchaseOrderCrew[${index}].plannedVesselRevisionId`,
                                          option?.value || ''
                                        );
                                        // Set vessel display fields
                                        form.setFieldValue(
                                          `purchaseOrderCrew[${index}].vesselName`,
                                          option?.name || ''
                                        );
                                        form.setFieldValue(
                                          `purchaseOrderCrew[${index}].vesselCode`,
                                          option?.vesselCode || ''
                                        );
                                        form.setFieldValue(
                                          `purchaseOrderCrew[${index}].imo`,
                                          option?.imoNumber || ''
                                        );
                                      }}
                                      className="w-full"
                                      options={vesselList}
                                      isDisabled={
                                        crew?.isShortClosed ||
                                        crew?.serviceStatus ||
                                        crew?.invoiceStatus?.toLowerCase().includes('payment') ||
                                        crew?.invoiceStatus?.toLowerCase().includes('voucher') ||
                                        crew?.invoiceStatus?.toLowerCase().includes('transferred')
                                      }
                                      rounded
                                      id="select1"
                                      type="text"
                                      placeholder=""
                                      label="Vessel"
                                    />
                                    <div className="error text-xs">
                                      {checkCrewError({
                                        touched: touched?.purchaseOrderCrew,
                                        errors: errors?.purchaseOrderCrew,
                                        index,
                                        fieldName: 'plannedVesselId',
                                      })}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flex flex-col mb-2">
                                    <label className="font-medium text-sm">Vessel</label>
                                    <div className="py-2 text-gray-100 font-semibold">
                                      {values?.purchaseOrderCrew?.[index]?.plannedVesselName || '-'}
                                    </div>
                                  </div>
                                )}
                              </div> */}

                              <div className="required-field">
                                <Field
                                  name={`purchaseOrderCrew[${index}].expenseLineItemId`}
                                  component={DropdownFieldComponent}
                                  className="w-full"
                                  special={{ label: crew?.expenseLineItem }}
                                  options={expenseitemsData}
                                  setFieldsNull={[`purchaseOrderCrew[${index}].amount`, `purchaseOrderCrew[${index}].categoryDetails`]}
                                  isDisabled={
                                    crew?.isShortClosed ||
                                    crew?.serviceStatus ||
                                    crew?.invoiceStatus?.toLowerCase().includes('payment') ||
                                    crew?.invoiceStatus?.toLowerCase().includes('voucher') ||
                                    crew?.invoiceStatus?.toLowerCase().includes('transferred')
                                  }
                                  rounded
                                  id="select1"
                                  type="text"
                                  placeholder=""
                                  label="Expense Line Item"
                                />
                                <div className="error text-xs">
                                  {checkCrewError({
                                    touched: touched?.purchaseOrderCrew,
                                    errors: errors?.purchaseOrderCrew,
                                    index,
                                    fieldName: 'expenseLineItemId',
                                  })}
                                </div>
                              </div>

                              <Field
                                name={`purchaseOrderCrew[${index}].accountCode`}
                                component={InputFieldComponent}
                                className="w-full"
                                id="number"
                                size="medium"
                                variant="text"
                                rounded
                                disabled
                                value={getAccountCode(index) || ''}
                                label="Account Code"
                              />
                              {showLineItemSapPoNumber && index < (dataObj?.purchaseOrderCrew?.length || 0) && (
                                <Field
                                  name={`purchaseOrderCrew[${index}].sapPoNumber`}
                                  component={InputFieldComponent}
                                  className="w-full"
                                  id="sapPoNumber"
                                  size="medium"
                                  variant="text"
                                  rounded
                                  disabled
                                  value={values?.purchaseOrderCrew?.[index]?.sapPoNumber || '-'}
                                  label="SAP PO Number"
                                />
                              )}
                              {mode === 'edit' && index < (dataObj?.purchaseOrderCrew?.length || 0) && (
                                <Field
                                  name={`purchaseOrderCrew[${index}].sapSequenceNumber`}
                                  component={InputFieldComponent}
                                  className="w-full"
                                  id="sapSequenceNumber"
                                  size="medium"
                                  variant="text"
                                  rounded
                                  disabled
                                  value={(values?.purchaseOrderCrew?.[index]?.sapSequenceNumber ?? '') !== ''
                                    ? values?.purchaseOrderCrew?.[index]?.sapSequenceNumber
                                    : '-'}
                                  label="SAP Sequence Number"
                                />
                              )}
                                 <div className="required-field">
                                <Field
                                  name={`purchaseOrderCrew[${index}].amount`}
                                  component={InputFieldComponent}
                                  className="w-full"
                                  onInput={(e) => {
                                    const value = e.target.value;
                                    const regex = new RegExp(/^\d{1,20}(\.\d{1,2})?$/);
                                    if (!regex.test(value)) {
                                      e.target.value = value.slice(0, -1);
                                    }
                                  }}
                                  id="number"
                                  size="medium"
                                  disabled={
                                    crew?.isShortClosed ||
                                    category?.label === 'PPE' ||
                                    category?.label === 'Vessel PPE' ||
                                    crew?.serviceStatus ||
                                    crew?.invoiceStatus?.toLowerCase().includes('payment') ||
                                    crew?.invoiceStatus?.toLowerCase().includes('voucher') ||
                                    crew?.invoiceStatus?.toLowerCase().includes('transferred')
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  variant="number"
                                  rounded
                                  autoComplete="off"
                                  placeholder="Enter amount"
                                  label="Amount"
                                />
                                <div className="error text-xs">
                                  {checkCrewError({
                                    touched: touched?.purchaseOrderCrew,
                                    errors: errors?.purchaseOrderCrew,
                                    index,
                                    fieldName: 'amount',
                                  })}
                                </div>
                              </div>
                            </div>

                        
                           
                           

                            {(category?.label === 'PPE' || category?.label === 'Vessel PPE') && (
                              <div>
                                <VesselAdhocPPE
                                  setFieldValue={setFieldValue}
                                  index={index}
                                  crew={crew}
                                  mode={mode}
                                  values={values}
                                  errors={errors}
                                  touched={touched}
                                  category={category}
                                  id={values?.expenseCategoryId}
                                  expenseCategoryList={expenseCategoryList}
                                />
                              </div>
                            )}

                            <ExpenseFieldForm
                              index={index}
                              crew={crew}
                              values={values}
                              checkIn={crew?.categoryDetails?.[0]?.value}
                              checkOut={crew?.categoryDetails?.[1]?.value}
                              category={category}
                              id={values?.expenseCategoryId}
                              expenseCategoryList={expenseCategoryList}
                            />

                            <div className="text-right pt-4">
                              <Button
                                type="button"
                                className="rounded-md"
                                onClick={() => {
                                  remove(index);
                                }}
                                size="large"
                                variant={
                                  crew?.isShortClosed ||
                                  crew?.serviceStatus ||
                                  (values?.poStatus ? (values?.poStatus !== 'Draft' && index < dataObj?.purchaseOrderCrew?.length) : null) ||
                                  crew?.invoiceStatus?.toLowerCase().includes('payment') ||
                                  crew?.invoiceStatus?.toLowerCase().includes('voucher') ||
                                  crew?.invoiceStatus?.toLowerCase().includes('transferred')
                                    ? 'disabled'
                                    : 'outlined'
                                }
                                disabled={
                                  crew?.isShortClosed ||
                                  crew?.serviceStatus ||
                                  (values?.poStatus ? (values?.poStatus !== 'Draft' && index < dataObj?.purchaseOrderCrew?.length) : null) ||
                                  crew?.invoiceStatus?.toLowerCase().includes('payment') ||
                                  crew?.invoiceStatus?.toLowerCase().includes('voucher') ||
                                  crew?.invoiceStatus?.toLowerCase().includes('transferred')
                                }
                              >
                                DELETE
                              </Button>
                            </div>
                          </div>
                        </>
                      );
                    })
                  ) : (
                    <div />
                  )}
                </div>
              )}

              {openCrew && (
                <div className="pt-2 pb-2">
                  <Button
                    type="button"
                    className="rounded-md w-full w-100 max-w-full bg-amber-100"
                    onClick={() => {
                      const vesselRevisionId = plannedVesselRevisionId
                        || values?.purchaseOrderCrew?.[0]?.plannedVesselRevisionId
                        || dataObj?.plannedVesselRevisionId
                        || '';
                      push({
                        plannedVesselId: '',
                        expenseLineItemId: '',
                        amount: '',
                        accountCode: '',
                        ppeCategoryDetails: [],
                        ppeDeliveryRemarks: '',
                        categoryDetails: '',
                        vesselName: '',
                        vesselCode: '',
                        imo: '',
                        plannedVesselRevisionId: vesselRevisionId,
                      });
                      setShowDropdown(true);
                    }}
                    disabled={isbtndisabled}
                    hidden={(category?.label === 'PPE' || category?.label === 'Vessel PPE') && values?.purchaseOrderCrew.length > 0}
                    size="large"
                    variant="filled"
                  >
                    Add Item
                  </Button>
                </div>
              )}
            </>
          );
        }}
      />
    </>
  );
};

export default VesselForm;
